import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { TaskLineItem } from './task-line-item';

@Injectable({ providedIn: 'root' })
export class TaskLineItemService {

  urlEndpoint = 'task-line-items';

  constructor(private http: HttpClient) {}

  findAll(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  findById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  findByTaskId(taskId: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/task/${taskId}`).pipe(retry({ count: 2, delay: 1500 }));
  }

  save(item: TaskLineItem): Observable<ApiResponse> {
    if (item.taskLineItemId) {
      return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, item);
    }
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, item);
  }

  delete(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
  }

  saveAll(taskId: number, items: TaskLineItem[]): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/task/${taskId}/bulk`, items);
  }
}
